import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'kin-cookie-consent';

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(STORAGE_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  function accept() {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  }

  function reject() {
    localStorage.setItem(STORAGE_KEY, 'rejected');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label="Cookie consent"
      className="fixed bottom-0 inset-x-0 z-50 bg-white border-t border-cream-200 shadow-lg"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-gray-700 text-center sm:text-left">
          We use cookies to improve your experience. Read our{' '}
          <Link to="/cookies" className="text-primary-600 hover:text-primary-700 underline">
            Cookie Policy
          </Link>{' '}
          for details.
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <button onClick={reject} className="btn btn-secondary text-sm">
            Reject Non-Essential
          </button>
          <button onClick={accept} className="btn btn-primary text-sm">
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
}
